export default "__VITE_ASSET__E$IRF0J0__"